module.exports = __webpack_public_path__ + "e7e52c955aa33e618baf437a16539524.woff2";